import(/* webpackMode: "eager" */ "/app/app/app-beta/error.tsx");
